import React, { memo } from "react";
import useNetworkToolbar from "./index.hooks";
import { AppBar, Toolbar, Typography } from "@material-ui/core";
import { WifiOff } from "@material-ui/icons";

type NetworkToolbarProps = {};

const NetworkToolbar = ({}: NetworkToolbarProps) => {
  const { styles, classes, atomicStyles, online, t } = useNetworkToolbar();

  return !online ? (
    <AppBar position="fixed" color="inherit" className={styles.appBar}>
      <Toolbar>
        <WifiOff className={styles.icon} />
        <Typography variant="body1">
          {t(
            "Sei attualmente offline. L'accesso all'applicazione potrebbe essere limitato.",
          )}
        </Typography>
      </Toolbar>
    </AppBar>
  ) : null;
};

export default memo(NetworkToolbar);
